import React from "react";
import { Button } from "./Button";
import { ReactComponent as QrIcon } from "../icons/qr.svg";
import { ReactComponent as Copy } from "../icons/Clip.svg";
import { ReactComponent as DownloadIcon } from "../icons/download.svg";
import styles from "./QrDownloadInput.scss";
import configs from "../../utils/configs";
import { useClipboard } from "use-clipboard-copy";
import { defineMessage, useIntl } from "react-intl";

const copiedQRMessage = defineMessage({
  id: "invite-popover.qr-code-copy",
  defaultMessage: "The QR Code has been downloaded correctly"
});

const downloadedQRMessage = defineMessage({
  id: "invite-popover.qr-code-download",
  defaultMessage: "The QR Code has been copied"
});

export function QrDownloadInput({ buttonPreset, label,qrCode, ...rest }) {

  const intl = useIntl();

  const clipboard = useClipboard({
    copiedTimeout: 600
  });

  const copyLabel = intl.formatMessage(copiedQRMessage);
  const downloadLabel = intl.formatMessage(downloadedQRMessage);

  const download = async() => {
    const hubId = window.APP.hub.hub_id;
    const apiUrl = configs.CUSTOM_API_URL;
    const url = `${apiUrl}/metaverse-rooms/${hubId}/qr-download`;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };

    const response = await fetch(url, {
      method: 'PUT',
      headers
    });

    if (!response.ok) {
      console.error(`API request failed: ${response.status} ${response.statusText}`);

      return null;
    }

    const downloadUrl = await response.json();    

    var link = document.createElement('a');
    link.href = downloadUrl
    link.download = "qr.png"
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.dispatchEvent(new CustomEvent('toast-message', {detail: copyLabel}))
  }

  const copyQrCode = () => {
    window.dispatchEvent(new CustomEvent('toast-message', {detail: downloadLabel}))
    clipboard.copy(qrCode);
  }

  return (
    <>
      <div  className={styles.container}>
        <div className={styles.input}>
          <QrIcon className={styles.qrIconInput}/>
          {label}
        </div>
        <div className={styles.afterInput}>
          <Button onClick={copyQrCode} className={styles.button}>
            <Copy className={styles.qrIcon}></Copy>
          </Button>
          <Button className={styles.button} onClick={download}>
            <DownloadIcon  className={styles.qrIcon}></DownloadIcon>
          </Button>
        </div>
      </div>
    </>
  );
}
